import { useEffect, useState } from "react";
import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

export const BookmarkButton = ({ questionId, active = false, onChange, size = "md", className }) => {
  const [on, setOn] = useState(!!active);
  const [busy, setBusy] = useState(false);

  useEffect(() => setOn(!!active), [active]);

  const toggle = async (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (busy) return;
    setBusy(true);
    const next = !on;
    setOn(next);
    try {
      if (next) await api.post(`/bookmarks/${questionId}`);
      else await api.delete(`/bookmarks/${questionId}`);
      onChange?.(questionId, next);
      toast.success(next ? "Saved to bookmarks" : "Removed from bookmarks");
    } catch {
      setOn(!next);
      toast.error("Could not update bookmark");
    } finally {
      setBusy(false);
    }
  };

  const dim = size === "sm" ? "h-4 w-4" : "h-5 w-5";
  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      data-testid={`bookmark-btn-${questionId}`}
      aria-pressed={on}
      title={on ? "Remove bookmark" : "Bookmark this question"}
      className={cn(
        "inline-flex items-center justify-center rounded-full p-2 transition-colors",
        on ? "text-primary" : "text-muted-foreground hover:text-primary",
        className
      )}
    >
      <Bookmark className={cn(dim, on && "fill-current")} />
    </button>
  );
};
